module.exports = "/_next/static/images/google-play-09499b357b12eabe71ce300848fa7d61.png";